const onPageTransitionStart = () => {
  document.querySelector("body")!.classList.remove("page-is-transitioning");
};

export default onPageTransitionStart;
